export const snapHeaderBackgroundVar = '--snap-com-background-color';
